/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const campaigns = r => require.ensure([], () => r(require('./components/index')), 'campaigns');
// const campaignslive = r => require.ensure([], () => r(require('./components/live')), 'campaignslive');
const preview = r => require.ensure([], () => r(require('./components/preview')), 'campaigns');
const bulkpreview = r => require.ensure([], () => r(require('./components/bulkpreview')), 'campaigns');
const manageCampaign = {
    index:       r => require.ensure([], () => r(require('./components/manage/index')),         'manage-campaign'),
    create:      r => require.ensure([], () => r(require('./components/manage/create')),           'manage-campaign'),
    description: r => require.ensure([], () => r(require('./components/manage/edit/description')), 'manage-campaign'),
    email:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-campaign'),
    sms:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-campaign'),
    team:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-campaign'),
    whatsapp:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-campaign'),
    landing:     r => require.ensure([], () => r(require('./components/manage/edit/landing')),     'manage-campaign'),
    education:    r => require.ensure([], () => r(require('./components/manage/edit/education')),    'manage-campaign'),
    schedule:    r => require.ensure([], () => r(require('./components/manage/edit/schedule')),    'manage-campaign'),
    review:    r => require.ensure([], () => r(require('./components/manage/edit/review')),    'manage-campaign')
};
const scheduleCalendar = r => require.ensure([], () => r(require('./components/schedule_calendar')), 'campaigns');
const createNeedlePhishing = r => require.ensure([], () => r(require('./components/create_needle_phishing')), 'campaigns');
const creatorWorkspace = r => require.ensure([], () => r(require('./components/creator_workspace')), 'campaigns');
const approverWorkspace = r => require.ensure([], () => r(require('./components/approver_workspace')), 'campaigns');
export default [
    {
        name: 'create_needle_phishing',
        path: '/create-needle-phishing',
        component: createNeedlePhishing,
    },
    {
        name: 'schedule_calendar',
        path: '/schedule-calendar',
        component: scheduleCalendar,
    },
    {
        name: 'campaigns',
        path: '/campaigns',
				// alias: '/announcements',
				alias: ['/announcements', '/policy'],
        component: campaigns,
    },
    {
        name: 'campaigns.index',
        path: '/campaigns/create',
        // alias: '/announcements/create',
        alias: ['/announcements/create','/policy/create'],
        component: manageCampaign.index,
        redirect: { name: 'campaigns.create' },
        children: [
            {
                name: 'campaigns.create',
                path: '/campaigns/create',
                alias: ['/announcements/create','/policy/create'],
                component: manageCampaign.create,
            },
            {
                name: 'campaigns.edit.description',
                path: '/campaigns/description/:id',
                alias: ['/announcements/description/:id','/policy/description/:id'],
                component: manageCampaign.description,
            },
            {
                name: 'campaigns.edit.email',
                path: '/campaigns/email/:id',
                alias: ['/announcements/email/:id','/policy/email/:id'],
                component: manageCampaign.email,
            },
            {
                name: 'campaigns.edit.team',
                path: '/campaigns/team/:id',
                alias: '/announcements/team/:id',
                component: manageCampaign.team,
            },
            {
                name: 'campaigns.edit.whatsapp',
                path: '/campaigns/whatsapp/:id',
                alias: '/announcements/whatsapp/:id',
                component: manageCampaign.whatsapp,
            },
            {
                name: 'campaigns.edit.sms',
                path: '/campaigns/sms/:id',
                alias: ['/announcements/sms/:id','/policy/sms/:id'],
                component: manageCampaign.sms,
            },
            {
                name: 'campaigns.edit.landing',
                path: '/campaigns/landing/:id',
                alias: ['/announcements/landing/:id','/policy/landing/:id'],
                component: manageCampaign.landing,
            },
            {
                name: 'campaigns.edit.education',
                path: '/campaigns/education/:id',
                alias: ['/announcements/education/:id','/policy/education/:id'],
                component: manageCampaign.education,
            },
            {
                name: 'campaigns.edit.schedule',
                path: '/campaigns/schedule/:id',
                alias: ['/announcements/schedule/:id','/policy/schedule/:id'],
                component: manageCampaign.schedule,
            },
            {
                name: 'campaigns.edit.review',
                path: '/campaigns/review/:id',
                alias: ['/announcements/review/:id','/policy/review/:id'],
                component: manageCampaign.review,
            }
        ]
    },
    {
			name: 'preview',
			path: '/campaigns/preview/:id',
			alias: ['/announcements/preview/:id','/policy/preview/:id'],
			component: preview,
    },
    {
			name: 'bulk/preview',
			path: '/campaigns/bulk/preview/:id',
			component: bulkpreview,
    },
    {
			name: 'creatorWorkspace',
			path: '/campaigns/creator-workspace',
			alias: ['/announcements/creator-workspace', '/policy/creator-workspace'],
			component: creatorWorkspace,
    },
    {
			name: 'approverWorkspace',
			path: '/campaigns/approver-workspace',
			alias: ['/announcements/approver-workspace', '/policy/approver-workspace'],
			component: approverWorkspace,
    },
]







// WEBPACK FOOTER //
// ./src/app/campaign/routes.js